module.exports = __webpack_public_path__ + "static/media/appOrGameText.8ebd479c.svg";